package com.flowyride.core.fileexport

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get

@Composable
actual fun rememberFilePicker(
    extensions: List<String>,
    onPicked: (PickedFile) -> Unit,
    onFailed: (Throwable) -> Unit,
): FilePicker {
    val picked by rememberUpdatedState(onPicked)
    val failed by rememberUpdatedState(onFailed)
    return remember(extensions) {
        FilePicker {
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.accept = extensions.joinToString(",") { ".$it" }
            input.style.display = "none"
            input.onchange = {
                val file = input.files?.get(0)
                input.remove()
                if (file != null) {
                    val reader = FileReader()
                    reader.onload = { picked(PickedFile(file.name, reader.result.toString())) }
                    reader.onerror = { failed(IllegalStateException("Cannot read ${file.name}")) }
                    reader.readAsText(file)
                }
            }
            // Some browsers only open the chooser for inputs attached to the document.
            document.body?.appendChild(input)
            input.click()
        }
    }
}
